'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002414 from "./presto.-Freemium2-F-A-Add-View$$anon$14.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002416 from "./presto.-Freemium2-F-A-Add-View$$anon$16.js";
import * as $j_presto$002etypes$0024$002dConfigure2$002dF$002dA$002dFreemium$002dResponse$0024 from "./presto.types$-Configure2-F-A-Freemium-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$13() {
  this.aTX = null;
  this.aTP = null;
  this.aTQ = false;
  this.aTY = null;
  this.aTZ = false;
  this.aU2 = null;
  this.aTV = null;
  this.aTW = false;
  this.aTR = null;
  this.aTS = false;
  this.aTT = null;
  this.aTU = false;
  this.aU0 = false;
  this.aU1 = false;
  this.aTX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aU2 = "Configure2FAFreemiumResponse";
}
export { $c_Lpresto_Freemium2FAAddView$$anon$13 as $c_Lpresto_Freemium2FAAddView$$anon$13 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$13;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$13() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$13 as $h_Lpresto_Freemium2FAAddView$$anon$13 };
$h_Lpresto_Freemium2FAAddView$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aTX;
});
$p.M = (function() {
  if ((!this.aTQ)) {
    this.aTP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aTQ = true;
  }
  return this.aTP;
});
$p.O = (function() {
  if ((!this.aTZ)) {
    this.aTY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aTZ = true;
  }
  return this.aTY;
});
$p.D = (function() {
  return this.aU2;
});
$p.t = (function() {
  if ((!this.aTW)) {
    this.aTV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("results", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aTW = true;
  }
  return this.aTV;
});
$p.N = (function() {
  if ((!this.aTS)) {
    this.aTR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002414.$c_Lpresto_Freemium2FAAddView$$anon$14())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aTS = true;
  }
  return this.aTR;
});
$p.Q = (function() {
  if ((!this.aTU)) {
    this.aTT = new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002416.$c_Lpresto_Freemium2FAAddView$$anon$16();
    this.aTU = true;
  }
  return this.aTT;
});
$p.v = (function() {
  if ((!this.aU1)) {
    this.aU0 = false;
    this.aU1 = true;
  }
  return this.aU0;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee137) => ((p) => \u03b4scrutinee137.cHj(p)))($j_presto$002etypes$0024$002dConfigure2$002dF$002dA$002dFreemium$002dResponse$0024.$m_Lpresto_types$Configure2FAFreemiumResponse$())));
});
var $d_Lpresto_Freemium2FAAddView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$13, "presto.Freemium2FAAddView$$anon$13", ({
  IQ: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$13 as $d_Lpresto_Freemium2FAAddView$$anon$13 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$13.js.map
